"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpecificitiesInfo = void 0;
exports.getSpecificityChoice = getSpecificityChoice;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _IntlMessages = _interopRequireDefault(require("react-platform-components/dist/Translations/IntlMessages"));
var _CollapseWrapper = require("./CollapseWrapper");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SpecificitiesInfo = function SpecificitiesInfo(props) {
  var product = props.product;
  return /*#__PURE__*/_react.default.createElement(_CollapseWrapper.CollapseWrapper, {
    label: /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
      id: "Specificities"
    })
  }, product.product_specificities.map(function (specificity) {
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      key: specificity.uuid,
      item: true,
      container: true,
      spacing: 1
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, null, specificity.name)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/_react.default.createElement(_core.Box, {
      component: _core.Typography,
      color: "black"
    }, getSpecificityChoice(specificity))));
  }));
};
exports.SpecificitiesInfo = SpecificitiesInfo;
function getSpecificityChoice(specificity) {
  var _specificity$choices$2;
  switch (specificity.type) {
    case "m_list":
      return specificity.choice.map(function (choice) {
        var _specificity$choices$;
        return (_specificity$choices$ = specificity.choices.find(function (_ref) {
          var value = _ref.value;
          return value === choice;
        })) === null || _specificity$choices$ === void 0 ? void 0 : _specificity$choices$.label;
      }).join(", ");
    case "list":
      return (_specificity$choices$2 = specificity.choices.find(function (_ref2) {
        var value = _ref2.value;
        return value === specificity.choice;
      })) === null || _specificity$choices$2 === void 0 ? void 0 : _specificity$choices$2.label;
    case "range":
      return specificity.choice[0] === specificity.choice[1] ? specificity.choice[0] : "[".concat(specificity.choice.join(" - "), "]");
    case "boolean":
      return specificity.choice ? /*#__PURE__*/_react.default.createElement(_core.Icon, {
        color: "primary"
      }, "check_circle") : /*#__PURE__*/_react.default.createElement(_core.Icon, {
        color: "error"
      }, "remove_circle");
    default:
      return specificity.choice;
  }
}